import { useEffect } from "react";

const ComprehensiveSelectionPage = ({
  worksheet,
  selectedTypes,
  setSelectedTypes,
}) => {
  const maxExamIndex =
    setSelectedTypes === undefined ? 99 : worksheet.data.length;
  const examIndex =
    selectedTypes.find((item) => item.key === "comprehensive")?.index || 0;

  const setExamIndex = (index) => {
    setSelectedTypes([{ key: "comprehensive", index }]);
  };

  useEffect(() => {
    if (setSelectedTypes !== undefined) {
      setExamIndex(maxExamIndex);
    }
  }, [maxExamIndex]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        padding: "20px",
      }}
    >
      내용이해 워크북 세트 선택
      <select
        id="typeSelect"
        value={examIndex}
        onChange={(e) => setExamIndex(e.target.value)}
        disabled={setSelectedTypes === undefined}
        style={{
          padding: "10px",
          paddingLeft: "15px",
          fontSize: "16px",
          color: "#737373",
          width: "130px",
          border: "1px solidrgb(29, 22, 22)",
          borderRadius: "5px",
          cursor: "pointer",
          backgroundColor: "white",
        }}
        className="customSelect"
      >
        {[...Array(maxExamIndex)].map((_, index) => (
          <option key={index + 1} value={index + 1}>
            {index + 1}번 세트
          </option>
        ))}
      </select>
    </div>
  );
};

export default ComprehensiveSelectionPage;
